import { useState, useEffect } from "react";
import { Send, Instagram, Menu, X } from "lucide-react";
import { BRAND } from "./data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Oferta", href: "#oferta" },
    { label: "Opinie", href: "#opinie" },
    { label: "Analiza", href: "#analiza" },
    { label: "Jak to działa", href: "#proces" },
  ];

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#050505]/80 border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between">
          <a
            href="#top"
            data-testid="brand-logo"
            className="flex items-center gap-2.5 group"
          >
            <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#00FF66] text-black font-display font-bold text-sm">
              HS
              <span className="absolute -inset-px rounded-md ring-1 ring-[#00FF66]/40 group-hover:ring-[#00FF66] transition" />
            </span>
            <span className="font-display font-semibold tracking-tight text-white text-base md:text-lg">
              HypeSignals
              <span className="text-[#00FF66]">_4u</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="text-sm font-medium text-neutral-400 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-instagram-link"
              className="h-10 w-10 inline-flex items-center justify-center rounded-lg border border-white/10 text-neutral-300 hover:text-white hover:border-white/30 transition"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={BRAND.telegram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-telegram-cta"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-lg bg-[#00FF66] text-black font-semibold text-sm hover:bg-[#00CC52] transition-all hover:scale-[1.02] active:scale-[0.98] hs-button-glow"
            >
              <Send className="h-4 w-4" />
              Dołącz do Telegrama
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden h-10 w-10 inline-flex items-center justify-center rounded-lg border border-white/10 text-white"
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-white/[0.06] bg-[#050505]/95 backdrop-blur-xl"
        >
          <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-neutral-300 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href={BRAND.telegram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-telegram-cta"
              className="mt-2 inline-flex items-center justify-center gap-2 h-12 rounded-lg bg-[#00FF66] text-black font-semibold text-sm"
            >
              <Send className="h-4 w-4" />
              Dołącz do Telegrama
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
